var map = {
	"./template.bet575": 1631,
	"./template.bet575.tsx": 1631,
	"./template.bet777": 1632,
	"./template.bet777.tsx": 1632,
	"./template.betprofessor": 1633,
	"./template.betprofessor.tsx": 1633,
	"./template.betroyale": 1634,
	"./template.betroyale.tsx": 1634,
	"./template.buffalobet": 1635,
	"./template.buffalobet.tsx": 1635,
	"./template.chromabet": 1636,
	"./template.chromabet.tsx": 1636,
	"./template.default": 673,
	"./template.default.tsx": 673,
	"./template.epicodds": 1637,
	"./template.epicodds.tsx": 1637,
	"./template.fiestabet": 1638,
	"./template.fiestabet.tsx": 1638,
	"./template.gigabet": 1639,
	"./template.gigabet.tsx": 1639,
	"./template.goldenbet888": 1640,
	"./template.goldenbet888.tsx": 1640,
	"./template.goldenrush": 1641,
	"./template.goldenrush.tsx": 1641,
	"./template.hyperbet": 1642,
	"./template.hyperbet.tsx": 1642,
	"./template.juicybet": 1643,
	"./template.juicybet.tsx": 1643,
	"./template.junglebet": 1644,
	"./template.junglebet.tsx": 1644,
	"./template.magnumbet": 1645,
	"./template.magnumbet.tsx": 1645,
	"./template.oldgill": 1646,
	"./template.oldgill.tsx": 1646,
	"./template.puntcity": 1647,
	"./template.puntcity.tsx": 1647,
	"./template.puntgenie": 1648,
	"./template.puntgenie.tsx": 1648,
	"./template.pyramidbet": 1649,
	"./template.pyramidbet.tsx": 1649,
	"./template.questbet": 1650,
	"./template.questbet.tsx": 1650,
	"./template.slambet": 1651,
	"./template.slambet.tsx": 1651,
	"./template.sterlingparker": 1652,
	"./template.sterlingparker.tsx": 1652,
	"./template.sugarcastle": 1653,
	"./template.sugarcastle.tsx": 1653,
	"./template.templebet": 1654,
	"./template.templebet.tsx": 1654,
	"./template.titanbet": 1655,
	"./template.titanbet.tsx": 1655,
	"./template.ts": 986,
	"./template.vikingbet": 1656,
	"./template.vikingbet.tsx": 1656,
	"./template.volcanobet": 1657,
	"./template.volcanobet.tsx": 1657,
	"./template.wellbet": 1658,
	"./template.wellbet.tsx": 1658
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2468;